import { Box, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useEasierTheme } from "datalign-themes";
import ModalControlProps from "models/explorer/modal-control-props";
import { MaterialIcon } from "ui-widgets";

const DrawCustomSearch = (modalControlProps: ModalControlProps) => {
  const easierTheme = useEasierTheme();

  const { customSearch, parentDrawControl } = modalControlProps;
  const [selectedDraw, setSelectedDraw] = useState("none");
  const [selectedEdit, setSelectedEdit] = useState("none");
  // console.log(customSearch);

  function selectDrawTool(type: string) {
    const drawControl = parentDrawControl?._toolbars?.draw?._modes;
    const editControl = parentDrawControl?._toolbars?.edit?._modes;
    switch (type) {
      case "polyline":
        setTimeout(() => {
          if (drawControl?.polyline?.handler?._enabled) {
            drawControl?.polyline?.handler?.disable();
            setSelectedDraw("none");
          } else {
            drawControl?.polyline?.handler?.enable();
            setSelectedDraw("polyline");
          }
        }, 200);
        break;
      case "polygon":
        setTimeout(() => {
          if (drawControl?.polygon?.handler?._enabled) {
            drawControl?.polygon?.handler?.disable();
            setSelectedDraw("none");
          } else {
            drawControl?.polygon?.handler?.enable();
            setSelectedDraw("polygon");
          }
        }, 200);
        break;
      case "rectangle":
        setTimeout(() => {
          if (drawControl?.rectangle?.handler?._enabled) {
            drawControl?.rectangle?.handler?.disable();
            setSelectedDraw("none");
          } else {
            drawControl?.rectangle?.handler?.enable();
            setSelectedDraw("rectangle");
          }
        }, 200);
        break;
      case "circle":
        setTimeout(() => {
          if (drawControl?.circle?.handler?._enabled) {
            drawControl?.circle?.handler?.disable();
            setSelectedDraw("none");
          } else if (!drawControl?.circle?.handler?._enabled) {
            drawControl?.circle?.handler?.enable();
            setSelectedDraw("circle");
          }
        }, 200);
        break;
      case "marker":
        setTimeout(() => {
          if (drawControl?.marker?.handler?._enabled) {
            drawControl?.marker?.handler?.disable();
            setSelectedDraw("none");
          } else {
            drawControl?.marker?.handler?.enable();
            setSelectedDraw("marker");
          }
        }, 200);
        break;
      case "circlemarker":
        setTimeout(() => {
          if (drawControl?.circlemarker?.handler?._enabled) {
            drawControl?.circlemarker?.handler?.disable();
            setSelectedDraw("none");
          } else {
            drawControl?.circlemarker?.handler?._enabled
              ? drawControl?.circlemarker?.handler?.disable()
              : drawControl?.circlemarker?.handler?.enable();
            setSelectedDraw("circlemarker");
          }
        }, 200);
        break;
      case "edit":
        setTimeout(() => {
          if (editControl?.edit?.handler?._enabled) {
            editControl?.edit?.handler?.disable();
            setSelectedEdit("none");
          } else {
            editControl?.edit?.handler?.enable();
            setSelectedEdit("edit");
          }
        }, 200);
        break;
      case "delete":
        // console.log("delete call");
        setTimeout(() => {
          try {
            setSelectedDraw("none");
            setSelectedEdit("none");
            editControl?.remove?.handler?.removeAllLayers();
            editControl?.edit?.handler?.disable();
          } catch (error) {
            editControl?.remove?.handler?.removeAllLayers();
            // console.log(error);
          }
        }, 200);
        break;
      default:
        // console.log(parentDrawControl?._toolbars?.draw?._modes);
        break;
    }
    if (customSearch.latlong) {
      customSearch.latlong = undefined;
    }
  }

  return (
    <ToggleButtonGroup
      value={selectedDraw}
      onChange={(
        _event: React.MouseEvent<HTMLElement>,
        newAlignment: string | null,
      ) => {
        selectDrawTool(newAlignment ?? "none");
      }}
      exclusive
      sx={{ my: 1, p: 1, border: 1, borderRadius: 1, borderColor: "#c5c5c5" }}
    >
      <Tooltip title="Draw lines">
        <span>
          <ToggleButton
            sx={{
              minWidth: "auto",
              m: 0,
              p: 1,
              color:
                (customSearch.enabled && selectedEdit !== "none") ||
                selectedDraw !== "polyline"
                  ? easierTheme?.Colour.Primary()
                  : "disabled",
            }}
            disabled={customSearch.enabled || selectedEdit !== "none"}
            value="polyline"
          >
            <MaterialIcon icon="timeline" />
          </ToggleButton>
        </span>
      </Tooltip>
      <Tooltip title="Draw polygon">
        <span>
          <ToggleButton
            sx={{
              minWidth: "auto",
              m: 0,
              p: 1,
              color:
                (customSearch.enabled && selectedEdit !== "none") ||
                selectedDraw !== "polygon"
                  ? easierTheme?.Colour.Primary()
                  : "disabled",
            }}
            disabled={customSearch.enabled || selectedEdit !== "none"}
            value={"polygon"}
          >
            <MaterialIcon icon="pentagon" />
          </ToggleButton>
        </span>
      </Tooltip>
      <Tooltip title="Draw rectangle">
        <span>
          <ToggleButton
            sx={{
              minWidth: "auto",
              m: 0,
              p: 1,
              color:
                (customSearch.enabled && selectedEdit !== "none") ||
                selectedDraw !== "rectangle"
                  ? easierTheme?.Colour.Primary()
                  : "disabled",
            }}
            disabled={customSearch.enabled || selectedEdit !== "none"}
            value="rectangle"
          >
            <MaterialIcon icon="rectangle" />
          </ToggleButton>
        </span>
      </Tooltip>
      <Tooltip title="Draw circle">
        <span>
          <ToggleButton
            sx={{
              minWidth: "auto",
              m: 0,
              p: 1,
              color:
                (customSearch.enabled && selectedEdit !== "none") ||
                selectedDraw !== "circle"
                  ? easierTheme?.Colour.Primary()
                  : "disabled",
            }}
            disabled={customSearch.enabled || selectedEdit !== "none"}
            value="circle"
          >
            <MaterialIcon icon="circle" />
          </ToggleButton>
        </span>
      </Tooltip>
      <Tooltip title="Draw marker">
        <span>
          <ToggleButton
            sx={{
              minWidth: "auto",
              m: 0,
              p: 1,
              color:
                (customSearch.enabled && selectedEdit !== "none") ||
                selectedDraw !== "marker"
                  ? easierTheme?.Colour.Primary()
                  : "disabled",
            }}
            disabled={customSearch.enabled || selectedEdit !== "none"}
            value="marker"
          >
            <MaterialIcon icon="location_on" />
          </ToggleButton>
        </span>
      </Tooltip>
      <Tooltip title="Edit placed drawing">
        <span>
          <ToggleButton
            sx={{
              minWidth: "auto",
              m: 0,
              p: 1,
              color:
                customSearch.enabled || selectedEdit !== "none"
                  ? easierTheme?.Colour.Primary()
                  : "disabled",
            }}
            disabled={!customSearch.enabled && selectedEdit === "none"}
            value="edit"
          >
            <MaterialIcon icon="edit" />
          </ToggleButton>
        </span>
      </Tooltip>
      <Tooltip title="Remove placed drawing">
        <span>
          <ToggleButton
            sx={{
              minWidth: "auto",
              m: 0,
              p: 1,
              color:
                customSearch.enabled || selectedEdit !== "none"
                  ? easierTheme?.Colour.Primary()
                  : "disabled",
            }}
            disabled={!customSearch.enabled && selectedEdit === "none"}
            value="delete"
          >
            <MaterialIcon icon="delete_forever" />
          </ToggleButton>
        </span>
      </Tooltip>
    </ToggleButtonGroup>
  );
};

export default DrawCustomSearch;
